var map = {
	"./SpinGeneral_001.webp": 45369,
	"./SpinGeneral_002.webp": 80092,
	"./SpinGeneral_003.webp": 81631,
	"./SpinGeneral_004.webp": 96290,
	"./SpinGeneral_005.webp": 59309,
	"./SpinGeneral_006.webp": 16224,
	"./SpinGeneral_007.webp": 20067,
	"./SpinGeneral_008.webp": 11910,
	"./SpinGeneral_009.webp": 81665,
	"./SpinGeneral_010.webp": 56979,
	"./SpinGeneral_011.webp": 31216,
	"./SpinGeneral_012.webp": 90397,
	"./SpinGeneral_013.webp": 22706,
	"./SpinGeneral_014.webp": 2735,
	"./SpinGeneral_015.webp": 61868,
	"./SpinGeneral_016.webp": 82537,
	"./SpinGeneral_017.webp": 59790,
	"./SpinGeneral_018.webp": 51483,
	"./SpinGeneral_019.webp": 58680,
	"./SpinGeneral_020.webp": 82136,
	"./SpinGeneral_021.webp": 24955,
	"./SpinGeneral_022.webp": 45434,
	"./SpinGeneral_023.webp": 66533,
	"./SpinGeneral_024.webp": 40340,
	"./SpinGeneral_025.webp": 82199,
	"./SpinGeneral_026.webp": 72950,
	"./SpinGeneral_027.webp": 21329,
	"./SpinGeneral_028.webp": 12144,
	"./SpinGeneral_029.webp": 34355,
	"./SpinGeneral_030.webp": 36917,
	"./SpinGeneral_031.webp": 91402,
	"./SpinGeneral_032.webp": 84395,
	"./SpinGeneral_033.webp": 44488,
	"./SpinGeneral_034.webp": 41473,
	"./SpinGeneral_035.webp": 26630,
	"./SpinGeneral_036.webp": 90887,
	"./SpinGeneral_037.webp": 37188,
	"./SpinGeneral_038.webp": 13549,
	"./SpinGeneral_039.webp": 57986,
	"./SpinGeneral_040.webp": 17330,
	"./SpinGeneral_041.webp": 77245,
	"./SpinGeneral_042.webp": 68592,
	"./SpinGeneral_043.webp": 79027,
	"./SpinGeneral_044.webp": 29294,
	"./SpinGeneral_045.webp": 99017,
	"./SpinGeneral_046.webp": 31052,
	"./SpinGeneral_047.webp": 82639,
	"./SpinGeneral_048.webp": 8954,
	"./SpinGeneral_049.webp": 22981,
	"./SpinGeneral_050.webp": 999,
	"./SpinGeneral_051.webp": 86820,
	"./SpinGeneral_052.webp": 12065,
	"./SpinGeneral_053.webp": 42310,
	"./SpinGeneral_054.webp": 71435,
	"./SpinGeneral_055.webp": 63496,
	"./SpinGeneral_056.webp": 2901,
	"./SpinGeneral_057.webp": 35370,
	"./SpinGeneral_058.webp": 31807,
	"./SpinGeneral_059.webp": 53564,
	"./SpinGeneral_060.webp": 23756,
	"./SpinGeneral_061.webp": 64623,
	"./SpinGeneral_062.webp": 21678,
	"./SpinGeneral_063.webp": 44425,
	"./SpinGeneral_064.webp": 93104,
	"./SpinGeneral_065.webp": 18867,
	"./SpinGeneral_066.webp": 84594,
	"./SpinGeneral_067.webp": 35933,
	"./SpinGeneral_068.webp": 69876,
	"./SpinGeneral_069.webp": 9239,
	"./SpinGeneral_070.webp": 14873,
	"./SpinGeneral_071.webp": 30366,
	"./SpinGeneral_072.webp": 42303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44370;